import { BaseTransition } from './BaseTransition';

export class BaseFadeTransition extends BaseTransition {

    getFragmentShader(item) {
        return `
            precision mediump float;

            varying vec2 vTextureCoord;

            uniform sampler2D uSampler;
            uniform float opacity;

            void main() {
                vec4 color = texture2D(uSampler, vTextureCoord);
                color *= vec4(opacity);

                gl_FragColor = color;
            }
        `;
    }

    getUniformBaseData(item) {
        return {
            opacity: 0.0,
        };
    }

    getUniformStartData(item) {
        return {
            opacity: 1.0,
        };
    }

    getUniformEndData(item) {
        return {
            opacity: 0.0,
        };
    }

}
